import React from 'react'
import _ from 'underscore'

import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

import Brand from 'helpers/brand'

type BrandFieldsErrors = {
  brands?: string
}

type BrandFieldsProps = {
  selectedBrands: string[]
  onChangeCallback: (update: { brands: string[] }) => void
  errors?: BrandFieldsErrors
}

const BrandFields = ({ selectedBrands, onChangeCallback, errors = {} }: BrandFieldsProps) => {
  const allBrands = Brand.allBrandsOfCurrentBusinessUnit()

  const onBrandChange = (brand: string) => {
    const updatedBrands = _.contains(selectedBrands, brand)
      ? _.without(selectedBrands, brand)
      : _.union(selectedBrands, [brand])

    onChangeCallback({ brands: updatedBrands })
  }

  return (
    <FormSection title="Brands">
      {
        allBrands.map((brand) => (
          <Checkbox
            key={brand}
            label={Brand.productName(brand)}
            checked={selectedBrands.includes(brand)}
            onChange={() => onBrandChange(brand)}
            errorMessage={_.last(allBrands) === brand ? errors.brands : ''}
          /> // TODO: DWA-2639 refactor to wrap set of checkboxes in container and have one error field for container
        ))
      }
    </FormSection>
  )
}

export default BrandFields
